import type { IdentityStore, VoteApi, Wait } from "./ports";
import { withServiceBusyRetry } from "./service-busy-retry";

/** 同じIDストアを使う複数flowの同時identifyを、ブラウザ非依存のPromiseで共有する。 */
const inflightIdentifications = new WeakMap<IdentityStore, ReturnType<VoteApi["identify"]>>();

interface SharedIdentificationDependencies {
  readonly siteKey: string;
  readonly api: VoteApi;
  readonly identityStore: IdentityStore;
  readonly wait: Wait;
}

/** 保存済みIDを固定してidentifyし、共通規則で一時的混雑だけを一度再送する。 */
function identifyWithOneBusyRetry(dependencies: SharedIdentificationDependencies) {
  const visitorId = dependencies.identityStore.get();
  const request = {
    siteKey: dependencies.siteKey,
    ...(visitorId === undefined ? {} : { visitorId }),
  };
  return withServiceBusyRetry(() => dependencies.api.identify(request), dependencies.wait);
}

/**
 * 同じIdentityStoreで進む複数flowのidentifyを1回に合流し、採用結果を全呼び出し元へ返す。
 * 完了後は共有を解除し、投票時のvisitor_requiredなどによる再identifyを可能にする。
 */
export function getSharedIdentification(
  dependencies: SharedIdentificationDependencies,
): ReturnType<VoteApi["identify"]> {
  const existingIdentification = inflightIdentifications.get(dependencies.identityStore);
  if (existingIdentification !== undefined) {
    return existingIdentification;
  }

  const identification = (async () => {
    try {
      return await identifyWithOneBusyRetry(dependencies);
    } finally {
      inflightIdentifications.delete(dependencies.identityStore);
    }
  })();
  inflightIdentifications.set(dependencies.identityStore, identification);
  return identification;
}
